<script>
import DeviceStateHistoryDetailCycle from '@components/vis-device-state-history-detail-cycle'
import { formatPrettyDate } from '@utils/data/date-time'

import toggle from '@utils/design/toggle-info'

export default {
  components: {
    DeviceStateHistoryDetailCycle,
  },

  props: {
    cachedDeviceEventCycles: {
      type: Array,
      default: () => [],
    },
  },

  computed: {},

  methods: {},
}
</script>

<template>
  <div>
    <b-card
      v-for="cycle in cachedDeviceEventCycles"
      :key="cycle.name"
      :no-body="true"
      class="cachedDeviceEventCycles"
    >
      <div slot="header">
        <span class=" text-uppercase  font-weight-bold">{{ cycle.name }} </span>
      </div>

      <b-row>
        <b-col
          v-for="cycleEvent in cycle.cycleEvents"
          :key="cycleEvent.cycleEvent"
          md="12"
        >
          <DeviceStateHistoryDetailCycle :cached-cycle-event="cycleEvent" />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<style></style>
